import Vue from 'vue'
import {ActionTree, GetterTree, Module, MutationTree} from 'vuex';
import {RootState} from '../RootState';
import axios from "axios";
import {settings} from "@/plugins/settings";
import {IErrors} from "@/model/IErrors";
import {IShortUser} from "@/model/shortInterfaces";
import responseHandler from "@/plugins/errorHandling";

interface ServiceProviderUserState {
  users: IShortUser[];
  owners: IShortUser[];
  operators: IShortUser[];
  errors: IErrors;
}

const state: ServiceProviderUserState = {
  users: [],
  owners: [],
  operators: [],
  errors: {},
};

const getters: GetterTree<ServiceProviderUserState, RootState> = {
  users: (state) => state.owners.concat(state.operators),
  owners: (state) => state.owners,
  operators: (state) => state.operators,
  errors: (state) => state.errors,
};

const actions: ActionTree<ServiceProviderUserState, RootState> = {
  fetchServiceProvidersUsers: ({ commit }, spId): any => responseHandler.handle(
    () => axios({
      url: settings.endpoint + 'serviceProviders/' + spId + '/users',
      method: "GET",
    }),
    commit,
    'serviceProvidersUsersLoaded'
  ),
  connectOwner: ({ commit }, {serviceProviderId, userId, connect}): any => {
    return responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'serviceProviders/' + serviceProviderId + '/owners/' + userId,
        method: connect ? 'PUT' : 'DELETE',
      }),
      commit,
      'serviceProvidersUsersLoaded'
    )
  },
  connectOperator: ({ commit }, {serviceProviderId, userId, connect}): any => {
    return responseHandler.handle(
      () => axios({
        url: settings.endpoint + 'serviceProviders/' + serviceProviderId + '/operators/' + userId,
        method: connect ? 'PUT' : 'DELETE',
      }),
      commit,
      'serviceProvidersUsersLoaded'
    )
  },
  errors: ({commit}, errors: IErrors): any => {
    commit('errors', errors);
  },
  cleanError: ({commit}, index: any): any => {
    commit('cleanError', index);
  },
};

const mutations: MutationTree<ServiceProviderUserState> = {
  serviceProvidersUsersLoaded(state, payload) {
    state.owners = payload.owners;
    state.operators = payload.operators;
  },
  errors(state, payload: IErrors) {
    state.errors = payload;
  },
  cleanError(state, index: string) {
    Vue.delete(state.errors, index);
  },
};

const namespaced: boolean = true;

export const serviceProviderUserModule: Module<ServiceProviderUserState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
